(function()
{
	var Application = include('springroll.Application');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var Ease = include('createjs.Ease');
	var Polygon = include('collision.Polygon');
	var Sprite = include('PIXI.Sprite');
	var Texture = include('PIXI.Texture');
	var Point = include('PIXI.Point');
	var Tween = include('createjs.Tween');
	var UnitContainer = include('nature.UnitContainer');

	var Seed = function(id, floater)
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		var configSeeds = this.app.config.seeds;

		UnitContainer.call(this, null, configSeeds);

		this.id = id;

		var art = this.art = new pixiflash_lib.LifePowerup();
		art.sparkleFX.visible = false;
		art.anchor = new Point(0.5, 0.5);
		this.addChildAt(art, 0);

		mixin(this, nature.SeedActions);

		this.floating = true;
		this.tween.setPosition(configSeeds.idle.offsets[this.id]);
	};

	var s = UnitContainer.prototype;
	var p = extend(Seed, UnitContainer);

	namespace('nature').Seed = Seed;
}());
